// add types as we support them
// this list should be in sync with the list of supported field types from main app
export enum Fields {
  addressfield = "addressfield",
  currencyfield = "currencyfield",
  datefield = "datefield",
  emailfield = "emailfield",
  filefield = "filefield",
  fullnamefield = "fullnamefield",
  linkedrecordfield = "linkedrecordfield",
  linkfield = "linkfield",
  lookupfield = "lookupfield",
  multipleselectfield = "multipleselectfield",
  numberfield = "numberfield",
  numbersliderfield = "numbersliderfield",
  percentcompletefield = "percentcompletefield",
  percentfield = "percentfield",
  phonefield = "phonefield",
  ratingfield = "ratingfield",
  recordtitlefield = "recordtitlefield",
  signaturefield = "signaturefield",
  singleselectfield = "singleselectfield",
  smartdocfield = "richtextareafield",
  statusfield = "statusfield",
  textareafield = "textareafield",
  textfield = "textfield",
  timefield = "timefield",
  userfield = "userfield",
  teamfield = "teamfield",
  yesnofield = "yesnofield",
  durationfield = "durationfield",
  ipaddressfield = "ipaddressfield",
  colorpickerfield = "colorpickerfield",
  tagsfield = "tagsfield",
  duedatefield = "duedatefield",
  checklistfield = "checklistfield",
  daterangefield = "daterangefield",
}
